module.exports = __webpack_public_path__ + "static/media/3DPPA8.9131a4c0.jpg";